import { web3Provider } from './web3Provider';
import { apiService } from './apiService';

// KYT Service - handles blockchain analysis without requiring MetaMask
export const kytService = {
  // Initialize blockchain provider without requiring MetaMask
  initialize: async () => {
    try {
      return await web3Provider.initialize();
    } catch (error) {
      console.debug('KYT Service: Error initializing Web3, using mock provider:', error);
      return null;
    }
  },

  // Validate address without requiring MetaMask
  validateAddress: async (address: string, blockchain: string) => {
    try {
      const response = await apiService.post('/api/admin/kyt/validate', {
        address: address.trim(),
        blockchain
      });
      return response;
    } catch (error) {
      console.error('KYT Service: Error validating address:', error);
      throw error;
    }
  },

  // Analyze address without requiring MetaMask
  analyzeAddress: async (address: string, blockchain: string) => {
    try {
      const response = await apiService.post('/api/admin/kyt/analyze', {
        address: address.trim(),
        blockchain
      });
      return response;
    } catch (error) {
      console.error('KYT Service: Error analyzing address:', error);
      throw error;
    }
  },

  // Trace transactions without requiring MetaMask
  traceTransactions: async (
    address: string,
    blockchain: string,
    maxSteps: number = 7,
    includeZeroValue: boolean = false
  ) => {
    try {
      const response = await apiService.post('/api/admin/kyt/trace', {
        address: address.trim(),
        blockchain,
        maxSteps,
        includeZeroValue
      });
      return response;
    } catch (error) {
      console.error('KYT Service: Error tracing transactions:', error);
      throw error;
    }
  }
};
